var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Export',{attrs:{"workflowKey":_vm.workflowKey}},[_c('ExportTable',{attrs:{"tableHeaders":_vm.tableHeaders,"tableRows":_vm.tableRows,"tableHint":_vm.$t('Alle Werte in kg/ha')}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }